import { Component, Input } from '@angular/core';
import { ControlService } from '../library/control.service';
import { PlayerService } from '../library/player.service';
import { CallStoreService } from '../library/call-store/call-store.service';
import { RealtimeService } from '../library/realtime/realtime.service';
@Component({
  selector: 'app-call-tour',
  templateUrl: './call-tour.component.html',
  styleUrls: ['./call-tour.component.scss'],
  standalone: false
})
export class CallTourComponent {
  @Input() control: ControlService | undefined;
  @Input() player: PlayerService | undefined;
  @Input() realtime: RealtimeService | undefined;

  constructor(public callStore: CallStoreService) {}

  next() {
    if (this.control) {
      const hints = this.callStore.getHints();
      if (hints == '' || this.control.displayTourHint) {
        this.control.displayTour = false;

        const isRealTime = this.control.isRealTimeCall;
        const isGuided = this.realtime?.isGuided();
        if (isRealTime && isGuided) {
          console.log('Call Tour ::: Starting guided real-time call');
          this.realtime?.startCallRequest(false);
        } else {
          this.control.unpauseCall();
        }
        return;
      }

      if (hints != '') {
        this.control.displayTourHint = true;
      }
    }
  }
}
